/* NOHO card swipe test (2026-09-16). Initialises Flickity (already bundled by Impulse) on product cards
   for touch / small screens only. Desktop keeps the hover image. Re-scans after ajax collection reloads. */
(function () {
  var mq = window.matchMedia('(max-width: 769px), (pointer: coarse)');
  // perf 2026-10-22: slides 2-3 ship as <template>; swap them in once the card is on screen and the page is idle,
  // or immediately on first touch, so a swipe never waits on markup. Cards below the fold stay cheap.
  function hydrate(el) {
    el.querySelectorAll('template[data-noho-deferred]').forEach(function (t) { t.replaceWith(t.content.cloneNode(true)); });
    el.dataset.nohoHydrated = '1';
  }
  function hydrateSoon(el) {
    if (el.dataset.nohoHydrated) return;
    var run = function () { if (!el.dataset.nohoHydrated) hydrate(el); };
    ('requestIdleCallback' in window) ? requestIdleCallback(run, { timeout: 1500 }) : setTimeout(run, 400);
  }
  function init(el) {
    if (el.dataset.nohoReady || typeof Flickity === 'undefined') return;
    el.dataset.nohoReady = '1';
    el.addEventListener('touchstart', function () { if (!el.dataset.nohoHydrated) hydrate(el); }, { passive: true });
    el.addEventListener('pointerdown', function () { if (!el.dataset.nohoHydrated) hydrate(el); }, { passive: true });
    hydrateSoon(el);
    var card = el.closest('.grid-product');
    var link = card && card.querySelector('a.grid-product__link');
    var flkty = new Flickity(el, {
      contain: true, cellAlign: 'left', pageDots: true, prevNextButtons: false, wrapAround: false,
      setGallerySize: false, draggable: true, dragThreshold: 10, accessibility: false, selectedAttraction: 0.1, friction: 0.6
    });
    if (card) card.classList.add('noho-swipe-on');
    // a tap that is not a swipe still opens the product (the theme's link overlay now sits under the slider)
    flkty.on('staticClick', function () { if (link && link.href) window.location.href = link.href; });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { init(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '200px 0px' }) : null;
  function scan() {
    if (!mq.matches) return;
    document.querySelectorAll('[data-noho-card-slider]:not([data-noho-ready])').forEach(function (el) {
      io ? io.observe(el) : init(el);
    });
  }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('collection:reloaded', scan);   // Impulse ajax filtering / pagination
  window.addEventListener('load', scan);
  if (document.readyState !== 'loading') scan();
  // 2026-10-21: cards that arrive after load (PDP "You may also like", recently viewed, search, ajax pages)
  // never got a scan. Rescan, debounced, whenever product cards are added to the DOM.
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-noho-card-slider]') || n.querySelector('[data-noho-card-slider]'))) {
            clearTimeout(pending); pending = setTimeout(scan, 100); return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* NOHO D1 quick add (2026-09-26). One variant: POST /cart/add.js, then fire Impulse's own
   'ajaxProduct:added' so the cart drawer rebuilds, the bubble updates and the drawer opens.
   Several variants: use Impulse's quick-shop modal (theme.preloadProductModal), which Impulse
   only preloads on desktop hover; here we preload on tap and open it once it is ready. */
(function () {
  function added(btn, item) {
    // dispatch from a throwaway form so listeners that read event.target's [name=id] still work
    var f = document.createElement('form');
    f.hidden = true;
    f.innerHTML = '<input type="hidden" name="id" value="' + item.variant_id + '">';
    (btn.closest('.grid-product') || document.body).appendChild(f);
    f.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item, addToCartBtn: btn } }));
    f.remove();
  }
  function done(btn, cls) {
    btn.classList.remove('is-loading');
    btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, 1600);
  }
  function productUrl(btn) {
    var a = btn.closest('.grid-product') && btn.closest('.grid-product').querySelector('a.grid-product__link');
    return a && a.href;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-noho-qa]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.variantId) {
      btn.classList.add('is-loading');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok || !res.d.items) { throw new Error(res.d && res.d.description); }
          if (window.theme && theme.settings && theme.settings.cartType === 'page') { window.location = theme.routes.cartPage; return; }
          done(btn, 'is-added');
          added(btn, res.d.items[0]);
        })
        .catch(function () { btn.classList.remove('is-loading'); var u = productUrl(btn); if (u) window.location.href = u; });
      return;
    }

    // several variants: Impulse modal. Once preloaded, Impulse binds its own click handler to this
    // button (it carries .js-modal-open-quick-modal-ID), which stops propagation before we see it.
    var holder = document.getElementById('QuickShopHolder-' + btn.dataset.handle);
    if (!holder || !window.theme || typeof theme.preloadProductModal !== 'function') {
      var u = productUrl(btn); if (u) window.location.href = u; return;
    }
    btn.classList.add('is-loading');
    theme.preloadProductModal(btn.dataset.handle, btn.dataset.productId, btn);
    var tries = 0;
    (function wait() {
      if (holder.children.length) { btn.classList.remove('is-loading'); btn.click(); return; }
      if (++tries > 80) { btn.classList.remove('is-loading'); var u = productUrl(btn); if (u) window.location.href = u; return; }
      setTimeout(wait, 100);
    })();
  });
})();

/* 2026-10-22: a card image that fails to load (flaky mobile data mid-swipe showed a broken-image icon on iOS)
   gets one retry after 1.5s, then a second after 5s, by re-requesting the same URL. */
(function () {
  function retry(img) {
    var n = Number(img.dataset.nohoRetry || 0);
    if (n >= 2) return;
    img.dataset.nohoRetry = String(n + 1);
    setTimeout(function () {
      var src = img.currentSrc || img.src; if (!src) return;
      var u = new URL(src, location.href); u.searchParams.set('noho_retry', String(n + 1));
      var ss = img.getAttribute('srcset'); img.removeAttribute('srcset'); img.src = u.toString();
      if (ss) img.dataset.nohoSrcset = ss;
    }, n === 0 ? 1500 : 5000);
  }
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.closest && t.closest('.noho-card-slider, .grid-product, .nh-product')) retry(t);
  }, true);
})();
